import { render } from "./RemoveLocationCard.vue?vue&type=template&id=6201a6fa&scoped=true"
import script from "./RemoveLocationCard.vue?vue&type=script&lang=js"
export * from "./RemoveLocationCard.vue?vue&type=script&lang=js"

import "./RemoveLocationCard.vue?vue&type=style&index=0&id=6201a6fa&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6201a6fa"]])

export default __exports__